<template>
  <div v-if="remoteData.length === 0">
    <md-field>
      <md-skeleton avatar title :loading="remoteDataLoading" :row="8">
        <md-field>
          <md-cell-item>无数据</md-cell-item>
          <md-cell-item v-if="this.remoteError">{{this.remoteError}}</md-cell-item>
        </md-field>
      </md-skeleton>
    </md-field>
  </div>
  <div v-else>
    <md-field>
      <md-cell-item :title="remoteData.user.nickname" :brief="remoteData.user.username">
        <span class="holder" slot="left"><img :src='remoteData.user.avatar' style="width: 60px;"/></span>
      </md-cell-item>
    </md-field>
    <md-field>
      <md-cell-item title="我的挂号" arrow @click="onMyOrderList"></md-cell-item>
      <md-cell-item title="我的就诊人" arrow @click="onMyPatientList"></md-cell-item>
    </md-field>
    <md-field v-if="hospitalId">
      <md-cell-item title="去挂号" arrow @click="onGuahao"></md-cell-item>
    </md-field>
    <md-field>
      <md-button @click="onLogout">退出登录</md-button>
    </md-field>
  </div>
</template>

<script>
import cookie from "@utils/store/cookie"
import { logout } from '@api/user'
import { userGet } from '../api/daSetting'
import { Dialog, Field, CellItem, Button, Skeleton } from 'mand-mobile'

export default {
  name: 'Setting',
  components: {
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Skeleton.name]: Skeleton,
    [Button.name]: Button
  },
  data () {
    return {
      remoteData: [],
      remoteDataLoading: false,
      remoteError: null,
      hospitalId: null
    }
  },
  created () {
    let hospitalId = this.$route.query.h || null
    if (hospitalId === 'all') {
      hospitalId = null
      cookie.remove('hospital')
    }
    if (hospitalId != null) {
      cookie.set('hospital', hospitalId)
    }
    this.hospitalId = cookie.get('hospital') || null

    this.remoteDataLoading = true
    this.remoteError = null
    this.remoteData = []
    userGet().then(res => {
      this.remoteDataLoading = false
      if (res.data && res.status === 200) {
        this.remoteData = res.data
      } else {
        this.remoteError = res.msg
      }
    }).catch(err => {
      this.remoteDataLoading = false
      this.remoteError = err
      console.log('userGet.err=', err)
    })
  },
  methods: {
    onLogout() {
      logout().then(res => {
        this.$store.commit("LOGOUT")
        location.reload()
      }).catch(err => {
        Dialog.failed({
          title: '退出失败',
          content: err.msg
        })
      })
    },
    onGuahao() {
      this.$router.push({
        path: '/',
        query: {
          h: this.hospitalId
        }
      })
    },
    onMyOrderList () {
      this.$router.push({
        path: '/order-list'
      })
    },
    onMyPatientList () {
      this.$router.push({ path: '/patient-list' })
    }
  }
}
</script>
